module.exports = __webpack_public_path__ + "media/images/abacus-carbono-3c5bc755.png";